/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React, { useEffect, useState } from "react";
import { PAMV1RestUrl } from "../../constants/PatientManagementConstants";
import fetchHelper from "../../services/fetchHelper";
import { findConclusionStatementsFromIds } from "../../utils/reportStatementsUtil";

export default function ModalAnticoagulant({
  handleSubmit,
  patientId,
  statementIds,
  userId,
  anticoagulantStatusId,
}) {
  const [statementsInfo, setStatementsInfo] = useState([]);

  useEffect(() => {
    if (statementIds.length) {
      const statements = findConclusionStatementsFromIds(statementIds);
      setStatementsInfo(statements);
    }
  }, []);

  const handleConfirm = async () => {
    await fetchHelper.put(`${PAMV1RestUrl}/patient/${patientId}/anticoagulant-configuration`, {
      statements: statementIds,
      userId: userId,
      anticoagulantStatusId: anticoagulantStatusId,
    });

    handleSubmit();
  };

  return (
    <div className="modal modal-anticoagulant override-row popup show">
      <div className="modalContent confirm">
        <p>Do you want to confirm:</p>
        <ul>
          {Object.values(statementsInfo).map((statement, i) => (
            <li key={i}>
              <b>{statement}</b>
            </li>
          ))}
        </ul>
        <div className="content-buttons-Sign_Next">
          <button
            type="button"
            id="btn-anticoagulant-review"
            className="btn btn-sm btn-hide-section"
            onClick={handleSubmit}
          >
            Review Later
          </button>
          <button
            type="button"
            id="btn-anticoagulant-confirm"
            className="btn btn-sm btnSuccess"
            onClick={handleConfirm}
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
}
